import { Model } from "@react3l/react3l/core";

export class Duration extends Model {
  public id?: number;
  public name?: string;
}
